import apiClient from './apiClient';
import { ENDPOINTS } from '../constants/api';

/**
 * Order Service
 * Communicates with backend endpoints for fetching, adding, and updating Orders.
 */

/**
 * Fetches all orders
 * @returns {Promise<Array>} List of orders
 */
export async function getAllOrders() {
  const { data: response } = await apiClient.get(ENDPOINTS.orders.all);
  return response?.data || [];
}

/**
 * Fetches a single order by ID
 * @param {number} id
 * @returns {Promise<object>} Order details
 */
export async function getOrder(id) {
  const { data: response } = await apiClient.get(ENDPOINTS.orders.get(id));
  return response?.data;
}

/**
 * Creates a new Order
 * @param {{
 *   eventDate: string,
 *   totalPrice: number,
 *   advancePayment: number,
 *   description: string,
 *   requiredThings: string[],
 *   eventIds: number[],
 *   person: string,
 *   phone1: string,
 *   phone2: string,
 *   isDone: boolean
 * }} dto
 * @returns {Promise<object>} ApiResponse
 */
export async function addOrder(dto) {
  const { data: response } = await apiClient.post(ENDPOINTS.orders.add, dto);
  return response;
}

/**
 * Updates an existing Order
 * @param {number} id
 * @param {{
 *   eventDate: string,
 *   totalPrice: number,
 *   advancePayment: number,
 *   description: string,
 *   requiredThings: string[],
 *   eventIds: number[],
 *   person: string,
 *   phone1: string,
 *   phone2: string,
 *   isDone: boolean
 * }} dto
 * @returns {Promise<object>} ApiResponse
 */
export async function updateOrder(id, dto) {
  const { data: response } = await apiClient.put(ENDPOINTS.orders.update(id), dto);
  return response;
}

/**
 * Toggles status (isDone) of an Order
 * @param {number} id
 * @param {boolean} status
 * @returns {Promise<object>} ApiResponse
 */
export async function toggleOrderStatus(id, status) {
  const { data: response } = await apiClient.put(
    ENDPOINTS.orders.toggleStatus(id),
    null,
    { params: { status } }
  );
  return response;
}
